export default __webpack_public_path__ + "static/media/quick-guide-icon.5cb20eff.svg";